import React from 'react';
import { Autocomplete, Avatar, Box, TextField, Typography } from '@mui/material';
import { People as PeopleIcon } from '@mui/icons-material';
import type { MentionUser } from '../../comments/types';
import { getInitials, pickAvatarColor } from '../helpers/avatarHelpers';

type ColleagueSelectorProps = {
  employees: MentionUser[];
  loading: boolean;
  value: MentionUser | null;
  onChange: (colleague: MentionUser | null) => void;
};

export const ColleagueSelector: React.FC<ColleagueSelectorProps> = ({
  employees,
  loading,
  value,
  onChange,
}) => (
  <Autocomplete
    options={employees}
    loading={loading}
    getOptionLabel={(o) => o.name}
    value={value}
    onChange={(_, val) => onChange(val)}
    renderOption={({ key, ...optionProps }, option) => (
      <Box
        key={key}
        component="li"
        {...optionProps}
        sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
      >
        <Avatar
          sx={{
            width: 28,
            height: 28,
            fontSize: '0.7rem',
            bgcolor: pickAvatarColor(option.name),
          }}
        >
          {option.initials ?? getInitials(option.name)}
        </Avatar>
        <Typography variant="body2">{option.name}</Typography>
      </Box>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Select colleague"
        size="small"
        InputProps={{
          ...params.InputProps,
          startAdornment: value ? (
            <Avatar
              sx={{
                width: 24,
                height: 24,
                fontSize: '0.65rem',
                mr: 0.5,
                bgcolor: pickAvatarColor(value.name),
              }}
            >
              {value.initials ?? getInitials(value.name)}
            </Avatar>
          ) : (
            <PeopleIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />
          ),
        }}
      />
    )}
  />
);
